export enum UserType {
  AGENT_BUYER = 'AGENT_BUYER',
  AGENT_SECONDARY_BUYER = 'AGENT_SECONDARY_BUYER',
  AGENT_TEMPORARY_BUYER = 'AGENT_TEMPORARY_BUYER',
  AGENT_TEMPORARY_SECONDARY_BUYER = 'AGENT_TEMPORARY_SECONDARY_BUYER',
  AGENT_GUEST = 'AGENT_GUEST',
  AGENT_COMMERCIAL = 'AGENT_COMMERCIAL',
  AGENT_COMMERCIAL_SALE_ADMINISTRATION = 'AGENT_COMMERCIAL_SALE_ADMINISTRATION',
  AGENT_COMMERCIAL_PLANNING = 'AGENT_COMMERCIAL_PLANNING',
  AGENT_COMMERCIAL_SUPPORT1 = 'AGENT_COMMERCIAL_SUPPORT1',
  AGENT_COMMERCIAL_SUPPORT2 = 'AGENT_COMMERCIAL_SUPPORT2',
  AGENT_COMMERCIAL_GUEST='AGENT_COMMERCIAL_GUEST',
  ADMIN = 'ADMIN',
}
